import { X } from "lucide-react";

export function SuccessToast({
	open,
	title,
	message,
	onClose,
}: {
	open: boolean;
	title: string;
	message: string;
	onClose: () => void;
}) {
	if (!open) return null;

	return (
		<div className="fixed top-6 left-1/2 z-60 w-90 max-w-[calc(100vw-2rem)] -translate-x-1/2 rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-[0_18px_45px_rgba(15,23,42,0.10)]">
			<div className="flex items-start justify-between gap-4">
				<p className="text-sm font-semibold text-slate-900">{title}</p>
				<button
					type="button"
					aria-label="Cerrar"
					onClick={onClose}
					className="rounded-md p-1 text-slate-500 transition hover:bg-slate-100 hover:text-slate-700"
				>
					<X className="h-4 w-4" />
				</button>
			</div>
			<p className="mt-1 text-sm text-slate-600">{message}</p>
		</div>
	);
}
